import { AccordionContainer } from "../../../../../common/components/accordion/accordion.module"
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container"


export const DbaRegistriesGSTInfoComponent = ({ handleInnerFormChange, selectedDbaRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="Legal Entity Name"
                        name="legal_entity_name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.legal_entity_name',
                                selectedDbaRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigGst?.legal_entity_name}
                    />
                    <InputContainer
                        label="Business Address"
                        name="business_address"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.business_address',
                                selectedDbaRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigGst?.business_address}
                    />
                    <InputContainer
                        label="GST No"
                        name="gst_no"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.gst_no',
                                selectedDbaRegistry?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDbaRegistry?.RegConfigGst?.gst_no}
                    />
                    <InputContainer
                        label="City Code"
                        onValueChange={(newValue: any) => {
                            const citycodeData: any = newValue.map((option: any) => option?.id || '')
                            handleInnerFormChange(
                                citycodeData,
                                'RegConfigGst.city_code',
                                selectedDbaRegistry?.RegConfigGst

                            );
                        }}
                        type="multiselectText"
                        value={selectedDbaRegistry?.RegConfigGst?.city_code}
                    />
                </div>
            }
            expandedPanel="gst info"
            headerTitle="GST Info"
        />
    </>
)

export default DbaRegistriesGSTInfoComponent;